import _WidgetBase from "dijit/_WidgetBase";
import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Time from "csi/heading/Time";
import types from "csi/types";
import TimeTextBox from "csi/widget/TimeTextBox";

const UniversalTime = declare(Time, {
	/**
	 * @property {number} hours - optional hours parameter to add to universal time when setting it.
	 */
	hours: 0,
	/**
	 * @override
	 * Render time drop down
	 */
	toHtmlDynamic: function (ctx: Context, h: Heading, refNode: HTMLElement, params: any): TimeTextBox {
		this._addDynamicParams(ctx, h, params);
		return new TimeTextBox(params);
	},

	/**
	 * @override
	 * Returns the UTC Time without considering the time-zone of client machine
	 */
	_addDynamicParams(ctx: Context, h: Heading, params: any): void {
		if (params.constraints == null) {
			params.constraints = this._constraints;
		}
		if (params.value == null) {
			params.value = this._getValue(ctx, h);
		}
		params.value = params.value ? types.getUTCTimeDate(params.value) : null;
	},

	/**
	 * @override
	 * Return value in UTC time from time dropdown control
	 */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: _WidgetBase & Element): number {
		const dt = editNode.get("value");
		return dt && (dt instanceof Date) ? types.getUTCDateTime(dt, this.hours) : 0;
	},
});

export = UniversalTime;